import { getParty, PARTIES } from '@val/shared'
import { useCallback } from 'react'
import { setHighlightParty } from '../lib/config.ts'
import './valvakacontrols.css'

const ORDERED = [...PARTIES].sort((a, b) => a.order - b.order)

export function HighlightPicker({
  value,
  onChange,
}: {
  value: string
  onChange: (code: string) => void
}) {
  const set = useCallback(
    (code: string) => {
      setHighlightParty(code)
      onChange(code)
    },
    [onChange],
  )

  return (
    <label className="vc-highlight">
      <span className="dim">Vårt parti</span>
      <span className="vc-highlight__chip" style={{ background: getParty(value).color }} />
      <select value={value} onChange={(e) => set(e.target.value)} aria-label="Vårt parti">
        {ORDERED.map((p) => (
          <option key={p.code} value={p.code}>
            {p.shortName} – {p.name}
          </option>
        ))}
      </select>
    </label>
  )
}

export function KioskButton() {
  const start = () => {
    document.documentElement.requestFullscreen?.().catch(() => {})
    // Behåll ev. ?phase= så kioskskärmen visar rätt datamängd.
    const params = new URLSearchParams(window.location.search)
    params.set('kiosk', '1')
    window.location.assign(`/?${params.toString()}`)
  }
  return (
    <button
      type="button"
      className="pill-select vc-kiosk"
      onClick={start}
      title="Öppna helskärmsläge för storbildsskärm"
    >
      <svg viewBox="0 0 24 24" width="15" height="15" fill="none" aria-hidden>
        <path
          d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      Kioskläge
    </button>
  )
}
